/**
 * HTML タグを除去してプレーンテキストにする（履歴プレビュー等）。
 * DOM が使える環境では DOMParser、それ以外は正規表現フォールバック。
 */
export function stripHtmlTags(html: string): string {
  if (!html) return "";
  if (typeof window !== "undefined" && typeof window.DOMParser === "function") {
    const doc = new window.DOMParser().parseFromString(html, "text/html");
    return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
  }
  return html
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}
